export function SkyCloudPuff() {
    return (
        <>
            <svg className="puffs" width="118" height="26" viewBox="0 0 118 26" aria-hidden="true">
                <circle cx="30" cy="22" r="18" fill="currentColor" />
                <circle cx="58" cy="24" r="14" fill="currentColor" />
                <rect x="12" y="18" width="80" height="14" rx="7" fill="currentColor" />
            </svg>
        </>
    );
}
